
import FormGroup from "./FormGroup"
import {useState, useEffect} from 'react';

const CheckboxSelector = (props) => {
    const [checked, setChecked] = useState(Boolean(props.value));

    useEffect(() => {
        if(props.onLoad) {
            props.onLoad();
        }
    },[])

    useEffect(() => {
        setChecked(Boolean(props.value));
    }, [props.value]);

    const onChange = (e) => {
        const value = e.target.checked;
        setChecked(value);
        props.onChange(props.id, value);
    }

    return (
        <FormGroup {...props}>
            <input className="form-check-input"
                type="checkbox"
                name={props.id}
                checked={checked}
                onChange={onChange}
            />
        </FormGroup>
    )
}

export default CheckboxSelector;